import api from "../client.ts";


export type PersonalType = {
  id: number;
  uid: string;
  personne_id: string;
  domaine_id: any;
  date_naissance: string ;
  lieu_naissance: string ;
  fonction_id: any;
  email: string;
  grade_id: any;
  path_img: string;
  status: number;
  created_at: string ;
  updated_at: string;
  nom: string;
  postnom: string;
  prenom: string;
  sexe: "M" | "F" | string; // You can restrict to 'M' | 'F' if known
  adresse_id: number;
  telephone: string;
  ville: string;
  commune: string;
  quartier: string;
  avenue: string;
  personnel_id: number;
};

const getAll = async ():Promise<{size:number, data: PersonalType[]}> => {
  const { data } = await api.get("/personnel/readAll");
  return data;
};

const create = async (newUser:any) => {
  const { data } = await api.post("/personnel/create", newUser);
  return data;
};
const update = async (id:any, newUser:any) => {
  const { data } = await api.put(`/personnel/update?id=${id}`, newUser);
  return data;
};
const desactivate = async (id:any) => {
  const { data } = await api.get(`/personnel/desactive?id=${id}`);
  return data;
};
const activate = async (id:any) => {
  const { data } = await api.get(`/personnel/active?id=${id}`);
  return data;
};


export const personalController = {getAll,create,update,activate,desactivate}